module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FuHaqG/images/Cover.jpg?1684514558406",
      "alt": "This image is the cover for the book Arizona History: Past and Present"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Arizona History: Past and Present\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("ARIZONA HISTORY: Past and Present describes the lives of people and events that have made the Grand Canyon state a unique blend of newcomers and original inhabitants. This comprehensive book sheds light on Arizona’s unique history and physical characteristics along with in-depth coverage in its Arizona’s “Faces and Features” sections. Interested readers, students and teachers alike will find its subheads a focus for understanding the key points made by the author and required by the State for studying Arizona’s history. For teachers and parents, a comprehensive Teacher's Guide is also available to support the learning of key concepts, standards and vocabulary along with strategies for meeting diverse needs. This comprehensive, yet concise book will be an excellent resource for understanding Arizona’s Past and Present.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Dr. Dick Buscher, Linda Buscher, Teresa Jackway, Ken Jackway\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Long-time Arizona resident, Dr. Dick Buscher has taught adults and children the history of Arizona.  He has been officially recognized for many Arizona-related projects.  His doctoral work was centered on the history and environment of Arizona.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Cloud Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0